





















































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ConfirmDialog extends Vue {
  @Ref('triggerButton')
  triggerButton: HTMLButtonElement;

  @Prop({ default: false })
  alert?: boolean;

  closeModal() {
    this.$emit('close');
  }

  confirmation() {
    this.$emit('confirmation');
    this.$emit('close');
  }

  mounted() {
    this.triggerButton.click();
  }
}
